<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="16">
    <g fill="none" fill-rule="evenodd">
      <path
        fill="currentColor"
        d="M14 0a2 2 0 012 2v2.757l2.536 2.536a1 1 0 010 1.414L16 11.242V14a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2h12z"
      />
      <path
        d="M8.22 2.564c.774-.006 1.428.66 1.424 1.445a1.438 1.438 0 01-1.427 1.44 1.437 1.437 0 01-1.43-1.435 1.44 1.44 0 011.433-1.45zm1.926 9.906c-.494.548-1.1.888-1.847.94-.409.027-.818.054-1.22-.057-.738-.202-1.231-.877-1.136-1.634.094-.749.236-1.492.361-2.237.11-.649.226-1.296.332-1.944a1.102 1.102 0 00-.007-.324.368.368 0 00-.319-.335c-.106-.02-.22-.008-.323-.036-.146-.04-.305-.077-.425-.162-.198-.14-.158-.422.065-.518a.982.982 0 01.361-.069c.467-.008.933-.003 1.4-.003v.004c.476 0 .953-.002 1.43 0 .312.002.46.134.525.44.057.264-.017.512-.065.766-.2 1.068-.396 2.137-.59 3.207-.061.33-.115.662-.17.993-.009.056-.007.114-.006.17.007.651.419.74.89.55.133-.053.25-.145.378-.213.22-.118.338-.122.425-.02.106.126.096.31-.059.482z"
        fill="#FFF"
      />
    </g>
  </svg>
</template>
